import React from 'react';
import styled from 'styled-components';
import {
  FlexColumn,
  FlexRow,
  PageTile,
  SvgIcon,
  VerifiedIcon,
} from '@make-software/cspr-design';
import { BodyText, HeaderText, Tooltip, Link } from '@block-explorer/ui';
import { Avatar } from '../../../components';
import { Trans, useTranslation } from 'react-i18next';
import { AccountInfoResult } from '@block-explorer/entities';

const StyledPageTile = styled(PageTile)(({ theme }) => ({
  padding: '20px 0',
}));

const AccountRow = styled(FlexRow)(({ theme }) => ({
  padding: '0px 24px',
}));

const StyledIcon = styled(SvgIcon)(({ theme }) =>
  theme.withMedia({
    cursor: 'pointer',
    path: {
      fill: theme.styleguideColors.contentRed,
    },
  })
);

interface AccountInfoCentralizedProps {
  accountInfo: AccountInfoResult | undefined;
  accountInfoLoading: boolean | undefined;
  publicKey: string;
}

export const AccountInfoCentralized = ({
  accountInfo,
  accountInfoLoading,
  publicKey,
}: AccountInfoCentralizedProps) => {
  const { t } = useTranslation();

  const logo = accountInfo?.centralized_account_info?.avatar_url;
  const accountInfoUrl = accountInfo?.centralized_account_info?.url;

  return (
    <StyledPageTile>
      <AccountRow gap={32}>
        <FlexColumn>
          {logo ? (
            <Avatar
              src={logo}
              size="medium"
              loading={accountInfoLoading}
              alt={'Account logo'}
            />
          ) : (
            <Avatar
              hash={publicKey}
              size="medium"
              loading={accountInfoLoading}
            />
          )}
        </FlexColumn>
        <FlexColumn justify={'center'}>
          <FlexColumn gap={4} justify={'center'}>
            <FlexRow align={'center'}>
              <BodyText variation={'darkGray'} size={2} uppercase>
                <Trans t={t}>Known owner</Trans>
              </BodyText>
              <Tooltip
                tooltipContent={t(
                  'This account information was added by the CSPR.live team.'
                )}
              >
                <StyledIcon src={VerifiedIcon} marginLeft />
              </Tooltip>
            </FlexRow>
            <HeaderText scale={'xs'} size={2}>
              {accountInfo?.centralized_account_info?.name}
            </HeaderText>
          </FlexColumn>
          {accountInfoUrl && (
            <Link color="primaryBlue" href={accountInfoUrl} rel="noopener">
              <BodyText size={3} scale={'sm'}>
                {accountInfoUrl}
              </BodyText>
            </Link>
          )}
        </FlexColumn>
      </AccountRow>
    </StyledPageTile>
  );
};
